/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

Odigeo.defineWidget('accommodation_sortby_closeto', Odigeo.Widget.extend({
    modelClass: require('../modules/models/accommodation_sortby_closeto'),

    viewClass: require('../modules/views/accommodation_sortby_closeto'),

    reset: function() {
        this.view.resetGeocoderInput('');
        this.view.resetGeocoderResults();
        this.model.set({geocoderItemSelected: null}, {silent: true});
    },

    setDestination: function(destination) {
        if (Odigeo._.isObject(destination)) {
            this.view.destination = destination;
        }
    },

    blurGeocoder: function() {
        this.view.resetGeocoderInput(this.view.getItemSelected());
        this.view.resetGeocoderResults();
    },
}));
